import { useEffect, useState } from 'react';

const IconsPage = () => {
    const [icons, setIcons] = useState<any[]>([]);

    const importAll = (r: any) => {
        return r.keys().map(r);
    };
    useEffect(() => {
        const iconList = importAll(require.context('assets/icons', false, /\.(png|jpe?g|svg)$/));
        setIcons(iconList);
    }, []);

    return (
        <section
            style={{
                display: 'grid',
                gridTemplateColumns: 'auto auto auto auto auto auto auto auto',
            }}
        >
            {icons.map((icon, index) => (
                <div
                    className="center-inside"
                    key={index}
                    style={{ border: '1px solid #CED4DA', minHeight: 150 }}
                >
                    <img alt="" src={icon} />
                </div>
            ))}
        </section>
    );
};

export default IconsPage;
